module.exports = __webpack_public_path__ + "static/diana-7ce29cc85bd990a47a79500a0bef38dd.jpg";